module.exports = __webpack_public_path__ + "media/images/icons/flags/NI-99dda1b3db17bfa6f30de0e822e247ae.svg";